<template>
  <div class="my_img_pos_layer">
    <div :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-text="title" class="title" :style="{
        width: titleWidth + 'px'
      }"></span>
      <div class="jz_form_item__content">
        <ul class="jz_background__square">
          <li class="jz_background__square_item"
              v-for="(item,index) in $store.state.options.imgPosList" :key="index"
              @click="clickEvent(item.value)" :class="Result == item.value ? 'jz_background__square_item--active' : ''"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:'my_img_pos_index',
    props:{
      titleWidth: {
        type:String,
        default: '40'
      },
      title: { // 组件的标题
        type:String,
        default: ''
      },
      type: { // 组件的类型  one_level 一级组件 two_level 二级组件
        type:String,
        default: 'two_level'
      },
      value: { // 输入框的值
        type:String,
        default: ''
      },
    },
    data(){
      return {
        Result:this.value
      }
    },
    mounted() {
    },
    watch:{
      Result(val){
        this.$emit('update:value',val);//双向数据绑定
      },
      value(val){
        this.Result = this.value
      }
    },
    computed:{
    },
    methods:{
      clickEvent(val) {
        this.Result = val
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/my_img_pos/index.vue